import cn from "classnames";
import React from "react";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  active?: boolean;
  hasDot?: boolean;
  count?: number;
}

const ChartDot = React.forwardRef<HTMLDivElement, Props>(
  ({ active, hasDot, count = 0, className, ...rest }, ref) => {
    if (!hasDot && count === 0) return null;

    return (
      <div
        ref={ref}
        className={cn(
          "bg-card inline-flex h-4 items-center rounded-full shadow-md",
          className,
        )}
        {...rest}
      >
        {hasDot && (
          <div className="flex size-4 items-center justify-center">
            <div
              className={cn(
                "size-2 rounded-full",
                active ? "bg-chart-1" : "bg-border",
              )}
            />
          </div>
        )}
        {count > 0 && (
          <span
            className={cn(
              "text-muted-foreground text-[10px] leading-none font-medium",
              hasDot ? "pr-1.5" : "px-1.5",
            )}
          >
            +{count}
          </span>
        )}
      </div>
    );
  },
);

ChartDot.displayName = "ChartDot";

export default ChartDot;
